export default {"src":"/_next/static/media/logo-primary.40f2f866.svg","height":146,"width":384,"blurWidth":0,"blurHeight":0};